import config from "config/config";
import {HttpClientService} from "services/httpClient/httpClientService";
import {AccountService} from "../../account/accountService";
import {ApiResponse} from "../apiResponse";
import {
    DashboardVejledersamtaleModel,
    DashboardVejledersamtaleResponseModel
} from "../../../pages/dashboard/dashboardVejledersamtaler/DashboardVejledersamtaleModel";
import {
    DashboardForloebModel,
    DashboardForloebResponseModel
} from "../../../pages/dashboard/dashboardUddannelseslaeger/DashboardForloebModel";
import {DashboardFilterListModel, DashboardFilterModel} from "../../../pages/dashboard/models/DashboardFilter";
import {
    DashboardBrugerKompetenceProgressModel,
    DashboardBrugerKompetenceProgressResponseModel
} from "../../../pages/dashboard/dashboardKompetencer/DashboardBrugerKompetenceProgressModel";
import {
    DashboardBrugerKompetenceAktivitetModel,
    DashboardBrugerKompetenceAktivitetResponseModel
} from "../../../pages/dashboard/dashboardKompetencer/DashboardBrugerKompetenceAktivitetModel";
import {
    DashboardKompetenceKlarmeldtModel,
    DashboardKompetenceKlarmeldtResponseModel
} from "../../../pages/dashboard/dashboardKompetencer/DashboardKompetenceKlarmeldtModel";
import {
    DashboardVejledningModel,
    DashboardVejledningResponseModel
} from "../../../pages/dashboard/dashboardOpmaerksomhedspunkter/DashboardVejledningModel";
import {
    DashboardForloebManglerGodkendelseModel,
    DashboardForloebManglerGodkendelseResponseModel
} from "../../../pages/dashboard/dashboardOpmaerksomhedspunkter/DashboardForloebManglerGodkendelseModel";
import {
    DashboardUddannelsesplanModel,
    DashboardUddannelsesplanResponseModel
} from "../../../pages/dashboard/dashboardUddannelsesplaner/DashboardUddannelsesplanModel";
import {
    DashboardListForloebModel,
    DashboardListForloebResponseModel
} from "../../../pages/dashboard/dashboardList/models/DashboardListForloebModel";
import {PromiseWithCancel} from "../../httpClient/promiseWithCancel";
import {
    DashboardListUkoModel,
    DashboardListUkoResponseModel
} from "../../../pages/dashboard/dashboardList/models/DashboardListForloebUkoModel";
import {UserSendEmailResponseModel} from "../stamdataUser/UserSendEmailResponseModel";

export class DashboardApi {
    private httpClientService: HttpClientService;
    private userService: AccountService;

    private logbogBaseUrl = () => config.logbogApiUrl + "api/dashboard/";
    private getDashboardUddannelseslaegerUrl = () => this.logbogBaseUrl() + "uddannelseslaeger";
    private getDashboardVejledersamtalerUrl = () => this.logbogBaseUrl() + "vejledersamtaler";
    private getDashboardUddannelsesplanerUrl = () => this.logbogBaseUrl() + "uddannelsesplaner";
    private getDashboardkompetenceProgressUrl = () => this.logbogBaseUrl() + "kompetenceProgress";
    private getDashboardkompetenceAktivitetUrl = () => this.logbogBaseUrl() + "kompetenceAktivitet";
    private getDashboardForloebListUrl = () => this.logbogBaseUrl() + "list/forloeb"
    private getDashboardForloebUkoListUrl = () => this.logbogBaseUrl() + "list/forloebUko"
    private getDashboardUsersForEmailUrl = () => this.logbogBaseUrl() + "users/emails"
    private getDashboardOpmaerksomhedspunktkompetenceKlarmeldingerUrl = () => this.logbogBaseUrl() + "opmaerksomhedspunkt/kompetenceKlarmeldinger";
    private getDashboardOpmaerksomhedspunktVejledningUrl = () => this.logbogBaseUrl() + "opmaerksomhedspunkt/vejledning";
    private getDashboardForloebUdenGodkendelseUrl = () => this.logbogBaseUrl() + "opmaerksomhedspunkt/forloebUdenGodkendelse";

    private getForloebListWithCancel: PromiseWithCancel<ApiResponse<DashboardListForloebResponseModel[]>>;
    private getForloebListUkoWithCancel: PromiseWithCancel<ApiResponse<DashboardListUkoResponseModel[]>>;
    private getUddannelseslaegerWithCancel: PromiseWithCancel<ApiResponse<DashboardForloebResponseModel[]>>;
    private getVejledersamtalerWithCancel: PromiseWithCancel<ApiResponse<DashboardVejledersamtaleResponseModel[]>>;
    private getUddannelsesplanerWithCancel: PromiseWithCancel<ApiResponse<DashboardUddannelsesplanResponseModel[]>>;
    private getKompetenceProgressWithCancel: PromiseWithCancel<ApiResponse<DashboardBrugerKompetenceProgressResponseModel[]>>;
    private getKompetenceAktivitetWithCancel: PromiseWithCancel<ApiResponse<DashboardBrugerKompetenceAktivitetResponseModel[]>>;
    private getKompetenceKlarmeldtWithCancel: PromiseWithCancel<ApiResponse<DashboardKompetenceKlarmeldtResponseModel[]>>;
    private getVejledningWithCancel: PromiseWithCancel<ApiResponse<DashboardVejledningResponseModel[]>>;
    private getForloebManglerGodkendelseWithCancel: PromiseWithCancel<ApiResponse<DashboardForloebManglerGodkendelseResponseModel[]>>;

    cancelPendingRequests(): void {
        if (this.getForloebListWithCancel)
            this.getForloebListWithCancel.cancel();
        if (this.getUddannelseslaegerWithCancel)
            this.getUddannelseslaegerWithCancel.cancel();
        if (this.getVejledersamtalerWithCancel)
            this.getVejledersamtalerWithCancel.cancel();
        if (this.getUddannelsesplanerWithCancel)
            this.getUddannelsesplanerWithCancel.cancel();
        if (this.getKompetenceProgressWithCancel)
            this.getKompetenceProgressWithCancel.cancel();
        if (this.getKompetenceAktivitetWithCancel)
            this.getKompetenceAktivitetWithCancel.cancel();
        if (this.getKompetenceKlarmeldtWithCancel)
            this.getKompetenceKlarmeldtWithCancel.cancel();
        if (this.getVejledningWithCancel)
            this.getVejledningWithCancel.cancel();
        if (this.getForloebManglerGodkendelseWithCancel)
            this.getForloebManglerGodkendelseWithCancel.cancel();
    }

    constructor(httpClientService: HttpClientService, userService: AccountService) {
        this.httpClientService = httpClientService;
        this.userService = userService;
    }

    async getDashboardUddannelseslaeger(filter: DashboardFilterModel): Promise<DashboardForloebModel[]> {
        if (this.getUddannelseslaegerWithCancel)
            this.getUddannelseslaegerWithCancel.cancel();

        const url = this.getDashboardUddannelseslaegerUrl();
        this.getUddannelseslaegerWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardForloebResponseModel[]>, DashboardFilterModel>(url, filter);
        const uddannelseslaeger = await this.getUddannelseslaegerWithCancel;
        return uddannelseslaeger.data.map(x => DashboardForloebModel.Build(x));
    }

    async getVejledersamtaler(filter: DashboardFilterModel): Promise<DashboardVejledersamtaleModel[]> {
        if (this.getVejledersamtalerWithCancel)
            this.getVejledersamtalerWithCancel.cancel();

        const url = this.getDashboardVejledersamtalerUrl();
        this.getVejledersamtalerWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardVejledersamtaleResponseModel[]>, DashboardFilterModel>(url, filter);
        const vejledersamtaler = await this.getVejledersamtalerWithCancel;
        return vejledersamtaler.data.map(x => DashboardVejledersamtaleModel.Build(x));
    }

    async getUddannelsesplaner(filter: DashboardFilterModel): Promise<DashboardUddannelsesplanModel[]> {
        if (this.getUddannelsesplanerWithCancel)
            this.getUddannelsesplanerWithCancel.cancel();

        const url = this.getDashboardUddannelsesplanerUrl();
        this.getUddannelsesplanerWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardUddannelsesplanResponseModel[]>, DashboardFilterModel>(url, filter);
        const uddannelsesplaner = await this.getUddannelsesplanerWithCancel;
        return uddannelsesplaner.data.map(x => DashboardUddannelsesplanModel.Build(x));
    }

    async getKompetenceProgress(filter: DashboardFilterModel): Promise<DashboardBrugerKompetenceProgressModel[]> {
        if (this.getKompetenceProgressWithCancel)
            this.getKompetenceProgressWithCancel.cancel();

        const url = this.getDashboardkompetenceProgressUrl();
        this.getKompetenceProgressWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardBrugerKompetenceProgressResponseModel[]>, DashboardFilterModel>(url, filter);
        const kompetencer = await this.getKompetenceProgressWithCancel;
        return kompetencer.data.map(x => DashboardBrugerKompetenceProgressModel.Build(x));
    }

    async getKompetenceAktivitet(filter: DashboardFilterModel): Promise<DashboardBrugerKompetenceAktivitetModel[]> {
        if (this.getKompetenceAktivitetWithCancel)
            this.getKompetenceAktivitetWithCancel.cancel();

        const url = this.getDashboardkompetenceAktivitetUrl();
        this.getKompetenceAktivitetWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardBrugerKompetenceAktivitetResponseModel[]>, DashboardFilterModel>(url, filter);
        const kompetencer = await this.getKompetenceAktivitetWithCancel;
        return kompetencer.data.map(x => DashboardBrugerKompetenceAktivitetModel.Build(x));
    }

    async getOpmaerksomhedspunktKompetenceKlarmeldinger(filter: DashboardFilterModel): Promise<DashboardKompetenceKlarmeldtModel[]> {
        if (this.getKompetenceKlarmeldtWithCancel)
            this.getKompetenceKlarmeldtWithCancel.cancel();

        const url = this.getDashboardOpmaerksomhedspunktkompetenceKlarmeldingerUrl();
        this.getKompetenceKlarmeldtWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardKompetenceKlarmeldtResponseModel[]>, DashboardFilterModel>(url, filter);
        const kompetencer = await this.getKompetenceKlarmeldtWithCancel;
        return kompetencer.data.map(x => DashboardKompetenceKlarmeldtModel.Build(x));
    }

    async getOpmaerksomhedspunktVejledning(filter: DashboardFilterModel): Promise<DashboardVejledningModel[]> {
        if (this.getVejledningWithCancel)
            this.getVejledningWithCancel.cancel();

        const url = this.getDashboardOpmaerksomhedspunktVejledningUrl();
        this.getVejledningWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardVejledningResponseModel[]>, DashboardFilterModel>(url, filter);
        const kompetencer = await this.getVejledningWithCancel;
        return kompetencer.data.map(x => DashboardVejledningModel.Build(x));
    }

    async getForloebUdenGodkendelse(filter: DashboardFilterModel): Promise<DashboardForloebManglerGodkendelseModel[]> {
        if (this.getForloebManglerGodkendelseWithCancel)
            this.getForloebManglerGodkendelseWithCancel.cancel();

        const url = this.getDashboardForloebUdenGodkendelseUrl();
        this.getForloebManglerGodkendelseWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardForloebManglerGodkendelseResponseModel[]>, DashboardFilterModel>(url, filter);
        const gamleForloeb = await this.getForloebManglerGodkendelseWithCancel;
        return gamleForloeb.data.map(x => DashboardForloebManglerGodkendelseModel.Build(x));
    }

    async getDashboardForloebForTable(filter: DashboardFilterListModel): Promise<DashboardListForloebModel[]> {
        if (this.getForloebListWithCancel)
            this.getForloebListWithCancel.cancel();

        const url = this.getDashboardForloebListUrl();
        this.getForloebListWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardListForloebResponseModel[]>, DashboardFilterListModel>(url, filter);
        const result = await this.getForloebListWithCancel
        return result.data.map(x => DashboardListForloebModel.Build(x));
    }

    async getDashboardForloebForUkoTable(filter: DashboardFilterListModel): Promise<DashboardListUkoModel[]> {
        if (this.getForloebListUkoWithCancel)
            this.getForloebListUkoWithCancel.cancel();

        const url = this.getDashboardForloebUkoListUrl();
        this.getForloebListUkoWithCancel = this.httpClientService.PostWithCancellation<ApiResponse<DashboardListUkoResponseModel[]>, DashboardFilterListModel>(url, filter);
        const result = await this.getForloebListUkoWithCancel
        return result.data.map(x => DashboardListUkoModel.Build(x));
    }

    async getDashboardUsersForEmail(filter: DashboardFilterModel): Promise<UserSendEmailResponseModel[]> {
        const url = this.getDashboardUsersForEmailUrl();
        const result = await this.httpClientService.Post<ApiResponse<UserSendEmailResponseModel[]>, DashboardFilterModel>(url, filter, true);
        return result.data;
    }
}
